export default __webpack_public_path__ + "c4a945b.png";